import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Image, Menu } from "semantic-ui-react";
import logo from "./../../images/logo.svg";
// import { SignOutButton } from "../SignOut";
import AnalysesNav from "./AnalysesNav";
import DashboardsNav from "./DashboardsNav";
import OrganizationsNav from "./OrganizationsNav";
import { ISessionState } from "src/reducers/session";
import DatasourcesNav from "./DatasourcesNav";
import { getPhotoUrl } from "src/utils";

interface INavigationComponent {
  session: ISessionState;
  history: any;
  match: any;
  location: any;
}

const NavigationComponent = ({
  session,
  history,
  match,
  location,
}: INavigationComponent) => {
  const { authUser, roles, orgId } = session;
  return (
    <Menu
      direction="left"
      animation="overlay"
      vertical={true}
      width="thin"
      className="navigation__sidebar"
      inverted={true}
    >
      {authUser && (
        <NavigationAuth
          authUser={authUser}
          roles={roles}
          orgId={orgId}
          history={history}
          match={match}
          location={location}
        />
      )}
    </Menu>
  );
};

const NavigationAuth = ({ authUser, roles, orgId, history }: any) => {
  return (
    <React.Fragment>
      {renderLogo()}

      <OrganizationsNav
        authUser={authUser}
        roles={roles}
        orgId={orgId}
        history={history}
      />

      <Menu.Item>
        <AnalysesNav authUser={authUser} orgId={orgId} history={history} />
      </Menu.Item>

      <Menu.Item>
        <DashboardsNav authUser={authUser} orgId={orgId} history={history} />
      </Menu.Item>

      {/* <Menu.Item>
        <Menu.Header>Alerts</Menu.Header>

        <Menu.Menu>
          <Menu.Item
            name="list"
            onClick={() => history.push(routes.ALERTS(orgId))}
          />
          <Menu.Item
            name="New"
            onClick={() => history.push(routes.NEW_ALERT(orgId))}
          />
        </Menu.Menu>
      </Menu.Item> */}

      <Menu.Item>
        <DatasourcesNav authUser={authUser} orgId={orgId} history={history} />
      </Menu.Item>

      <Menu.Menu
        style={{ position: "absolute", bottom: "30px", width: "100%" }}
      >
        {/* <Menu.Item
          name="About"
          link={true}
          onClick={() => history.push(routes.LANDING)}
        /> */}
        <Menu.Item name="browse">
          <Image
            src={getPhotoUrl(authUser)}
            inline={true}
            avatar={true}
            spaced="right"
            style={{ borderRadius: "0" }}
          />
          {authUser.displayName}
        </Menu.Item>
      </Menu.Menu>
    </React.Fragment>
  );
};

// const NavigationNonAuth = ({ history }: any) => (
//   <React.Fragment>
//     {renderLogo()}

//     <Menu.Menu position="right">
//       <Menu.Item
//         name="About"
//         link={true}
//         onClick={() => history.push(routes.LANDING)}
//       />
//     </Menu.Menu>
//   </React.Fragment>
// );

const renderLogo = () => {
  return (
    <Menu.Item header={true}>
      <img
        alt="BotSights Logo"
        src={logo}
        width="100"
        style={{
          marginLeft: "-6px",
          filter:
            "invert(100%) sepia(100%) saturate(0%) hue-rotate(41deg) brightness(103%) contrast(101%)",
        }}
      />
    </Menu.Item>
  );
};

const mapStateToProps = (state: any) => ({
  session: state.sessionState,
});

export const Navigation = connect(mapStateToProps)(
  withRouter(NavigationComponent)
);



// WEBPACK FOOTER //
// ./src/components/Navigation/index.tsx